import React from "react";

type ImageProps = React.HTMLProps<HTMLImageElement> & {
  src: string;
  alt?: string;
  className?: string;
};

function Image({
  src,
  alt = "Image Name",
  className = "",
  ...props
}: ImageProps) {
  return <img src={src} alt={alt} className={className} {...props} />;
}

export default Image;
